export default __webpack_public_path__ + "static/media/categories_authentication.e4dc3a5e.svg";